import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { PopoverController, ModalController, AlertController } from '@ionic/angular/lazy';
import { StorageService } from 'src/app/services/storage.service';
import moment from 'moment';

@Component({
    selector: 'app-orders-quick-search',
    templateUrl: './orders-quick-search.component.html',
    styleUrls: ['./orders-quick-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class OrdersQuickSearchComponent implements OnInit {

    moment = moment;
    @Input() orders_page = null;
    search_params = {};

    constructor(
        private popoverCtrl: PopoverController,
        public modalController: ModalController,
        public alertController: AlertController,
        private storageService: StorageService,
    ) { }

    ngOnInit() {
    }

    todaysSales() {

        this.search_params['timeframe'] = "today";
        this.search_params['date_from'] = this.moment().startOf("day").utc().format();
        this.search_params['date_to'] = this.moment().endOf("day").utc().format();
        this.storageService.get('register_id').then((register_id) => {
            if(register_id) {
                this.search_params['register_id'] = register_id;
                this.orders_page.applyFilters(this.search_params);
                this.dismiss();
            }
        });

    }

    async dismiss() {
        try {
            await this.popoverCtrl.dismiss();
        } catch (e) {
            // click more than one time popover throws error, so ignore...
        }
    }

}
